/** One model from the Add models flow: `errorMessage` is null when it was added. */
export interface AddModelOutcome {
  errorMessage: string | null;
  modelId: string;
}

export interface AddModelsSummary {
  message: string;
  tone: 'error' | 'success';
}

/** Folds one result per selected model into the single message the Models page shows. */
export function summarizeAddModelsOutcomes(outcomes: AddModelOutcome[]): AddModelsSummary {
  const failures = outcomes.filter((outcome) => outcome.errorMessage !== null);
  const successCount = outcomes.length - failures.length;

  if (failures.length === 0) {
    return {
      tone: 'success',
      message: successCount === 1 ? 'Model added.' : `${successCount} models added.`,
    };
  }

  const failureMessages = failures.map((failure) => failure.errorMessage as string);

  return {
    tone: 'error',
    message:
      successCount > 0
        ? `${successCount} model(s) added; ${failures.length} failed: ${failureMessages.join(' ')}`
        : failureMessages.join(' '),
  };
}
